import { render, staticRenderFns } from "./DoctorAppointmentForm.vue?vue&type=template&id=6bf03fdf&"
import script from "./DoctorAppointmentForm.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorAppointmentForm.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bf03fdf')) {
      api.createRecord('6bf03fdf', component.options)
    } else {
      api.reload('6bf03fdf', component.options)
    }
    module.hot.accept("./DoctorAppointmentForm.vue?vue&type=template&id=6bf03fdf&", function () {
      api.rerender('6bf03fdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/DoctorAppointmentForm.vue"
export default component.exports